import { $authHost } from ".."
import { getStartParamsQuery } from "../../helpers/api/apiHelper"

export const addSupplyBillAPI = async (supplyBill) => {
    const {data} = await $authHost.post(`api/supply_bills/`, supplyBill)
    return data
}

export const editSupplyBillAPI = async (supplyBill) => {
    const {data} = await $authHost.post(`api/supply_bills/${supplyBill.supplyBillId}`, supplyBill)
    return data
}

export const editSupplyBillStatusAPI = async ({ supplyBillId, status }) => {
    const {data} = await $authHost.post(`api/supply_bills/status/${supplyBillId}`, { status })
    return data
}

export const editSupplyBillIsNakladnaAPI = async (supplyBill) => {
    const {data} = await $authHost.post(`api/supply_bills/change_nakladna/${supplyBill.id}`, supplyBill)
    return data
}

export const editSupplyBillIsNakladnaOriginalAPI = async (supplyBill) => {
    const {data} = await $authHost.post(`api/supply_bills/change_nakladna_original/${supplyBill.id}`, supplyBill)
    return data
}

export const sendToPaySupplyBillsCheckedAPI = async ({ checked, status }) => {
    const {data} = await $authHost.post(`api/supply_bills/send_to_pay/`, { checked, status })
    return data
}

export const agreeHeaderSupplyBillsCheckedAPI = async ({ checked, isAgreeLeadership, disagreeLeadershipText }) => {
    const {data} = await $authHost.post(`api/supply_bills/agree_header/`, { checked, isAgreeLeadership, disagreeLeadershipText })
    return data
}

export const getSupplyBillsByOrderIdAPI = async ({ supplyOrderId }) => {
    let params = ''

    if (supplyOrderId) {
        params = `?supplyOrderId=${supplyOrderId}`
    }

    const {data} = await $authHost.get(`api/supply_bills/by_order${params}`)
    return data
}

// export const createNewSupplyOrderFromOrderAPI = async ({ supplyOrderId, itemsChecked, userId }) => {
//     const {data} = await $authHost.post(`api/supply_orders/create_new_by_order`, { supplyOrderId, itemsChecked, userId })
//     return data
// }

// export const editSupplyOrderAPI = async (supplier) => {
//     const {data} = await $authHost.post(`api/supply_orders/${supplier.id}`, supplier)
//     return data
// }

// export const editSupplyOrderUserAPI = async ({ supplyOrderId, userId }) => {
//     const {data} = await $authHost.post(`api/supply_orders/${supplyOrderId}/user`, { userId })
//     return data
// }

export const getSupplyBillAPI = async ({ supplyBillId }) => {
    const {data} = await $authHost.get(`api/supply_bills/${supplyBillId}`)
    return data
}

export const getSupplyBillsAPI = async ({ 
    offset, limit, query, status, paymentStatus, agreeNachSupply, agreeEconomist, agreeDeputyDirectorSupply, agreeHeader, sortField, sortType
}) => {

    // let params = ''
    // if (query) {
    //     params = `?query=${query}`
    // } else if ((offset || offset === 0) && limit) {
    //     params = `?offset=${offset}&limit=${limit}`
    // }

    let params = ''
    if (query) {
        params = `${getStartParamsQuery({ params })}query=${query}`
    }
    
    if ((offset || offset === 0) && limit) {
        params += `${getStartParamsQuery({ params })}offset=${offset}&limit=${limit}`
    }

    if (status) {
        params += `${getStartParamsQuery({ params })}status=${status}`
    }

    if (paymentStatus) {
        params += `${getStartParamsQuery({ params })}paymentStatus=${paymentStatus}`
    }
    
    if (agreeNachSupply) {
        params += `${getStartParamsQuery({ params })}agreeNachSupply=${agreeNachSupply}`
    }
    if (agreeEconomist) {
        params += `${getStartParamsQuery({ params })}agreeEconomist=${agreeEconomist}`
    }
    if (agreeDeputyDirectorSupply) {
        params += `${getStartParamsQuery({ params })}agreeDeputyDirectorSupply=${agreeDeputyDirectorSupply}`
    }
    if (agreeHeader) {
        params += `${getStartParamsQuery({ params })}agreeHeader=${agreeHeader}`
    }
    
    if (sortField && sortType && sortType !== 'reset') {
        params += `${getStartParamsQuery({ params })}sortField=${sortField}&sortType=${sortType}`
    }

    const {data} = await $authHost.get(`api/supply_bills/${params}`)
    return data
}